import {mapActions, mapState} from 'vuex';
import FormDetail from './components/FormDetail';
import pagingMixin from './pagingMixin';

export default {
    components: {
        FormDetail
    },
    data: () => ({
        show: false,
        pagedForms: []
    }),
    mixins:[pagingMixin],
    computed: {
        ...mapState('form', ['selectedForm']),
        title() {
            if (this.selectedForm) {
                return `${this.selectedForm.formNo} ${this.selectedForm.applicant.name} - ${this.selectedForm.roomName}`;
            }
            return '';
        },
        applicant(){
            if (this.selectedForm) {
                return this.selectedForm.applicant.name;
            }
            return '';
        },

        isDenied() {
            if (this.selectedForm) {
                return this.selectedForm.isDenied;
            }
            return false;
        },

        denyReason(){
            if (this.selectedForm) {
                return this.selectedForm.denyReason;
            }
            return '';
        }
    },
    watch:{
      pagedData(current){
          this.pagedForms = [...current];
      }
    },
    methods:{
        ...mapActions('form', {
            getForm: 'getFormAction'
        }),
        async selectAndShow(row) {
            await this.select(row);
            this.showThis();
        },
        async select({id}) {
            await this.getForm(id);
        },
        showThis(){
            this.show = true;
        }
    }
}
